module.exports = __webpack_public_path__ + "static/media/icon-dash-invite.b162176f.png";